import {
  Component,
  input,
  OnChanges,
  OnInit,
  output,
  SimpleChanges,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IServiceInfoDetail } from 'src/app/models';
import { RoutesResolver } from 'src/app/resolvers';
import { LiteralService } from 'src/app/services';
import { TooltipPosition } from 'src/app/shared/tooltip/tooltip-position';
import { IServicesState } from 'src/app/store/states';
import { images } from 'src/images';
import { APP } from 'src/app/config/app';

@Component({
  selector: 'app-service-routes-modal',
  templateUrl: './service-routes-modal.component.html',
  styleUrl: './service-routes-modal.component.scss',
  standalone: false,
})
export class ServiceRoutesModalComponent implements OnInit, OnChanges {
  routes = input<IServicesState>();
  readonly serviceInfoRoutesSelected = input<IServiceInfoDetail>();
  readonly routeSelected = input<any>();
  readonly selectRoute = output<any>();
  readonly getRoutes = output<any>();
  readonly hideRoutes = output<any[]>();
  readonly close = output();
  readonly createEventEmitter = output();
  readonly multiConfigEventEmitter = output();
  readonly reorganizeEventEmitter = output();
  readonly designRoute = output<number>();

  public images = images;
  public TooltipPosition = TooltipPosition;
  public searching = false;

  public showedRoutes?: any[];
  public searchValue: string;

  constructor(
    public literalService: LiteralService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private routesResolver: RoutesResolver,
  ) {}

  ngOnInit() {
    const initialPageParam =
      this.activatedRoute.snapshot.queryParamMap.get('routesPage');
    if (initialPageParam && this.routes()) {
      const pageNumber = Number(initialPageParam);
      if (!isNaN(pageNumber) && pageNumber > 0) {
        this.routes()!.pagination.actualPage = pageNumber;
      }
    }
    this.routes()!.value.sort((r1: any, r2: any) => r1.name.localeCompare(r2.name, undefined, { numeric: true }));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['routes'] && changes['routes'].currentValue) {
      const storedHiddenRoutes: number[] = JSON.parse(
        localStorage.getItem(APP.LOCAL_STORAGE_HIDDEN_ROUTES) || '[]',
      ).map(Number);
      this.updateRoutesVisibility(storedHiddenRoutes);
    }
    if (changes['routeSelected']) {
      const change = changes['routeSelected'];
      if (change.currentValue) {
        this.routes()?.value.forEach(
          (route: any) =>
            (route.visible = route.id === this.routeSelected()?.id),
        );
      } else {
        const storedHiddenRoutes: number[] = JSON.parse(
          localStorage.getItem(APP.LOCAL_STORAGE_HIDDEN_ROUTES) || '[]',
        ).map(Number);
        this.updateRoutesVisibility(storedHiddenRoutes);
      }
    }
  }

  updateRoutesVisibility(hiddenIds: number[]) {
    this.routes()?.value.forEach(
      (route: any) => (route.visible = !hiddenIds.includes(route.id)),
    );
  }

  public search(event: any) {
    this.searching = true;
    this.routes()!.value = [];
    this.searchValue = event;
    this.routes()!.pagination.actualPage = 1;
    this.getRoutes.emit({ searchValue: this.searchValue, close: false });
    this.updateUrlWithPage();
    this.searching = false;
  }

  async changePageRoutes(event: { isNext: boolean; specificPage?: number }) {
    this.searching = true;
    const routes = this.routes()!;
    if (!event.specificPage) {
      routes.pagination.actualPage = event.isNext
        ? routes.pagination.actualPage + 1
        : routes.pagination.actualPage - 1;
    } else {
      routes.pagination.actualPage = event.specificPage;
    }
    this.getRoutes.emit({ page: routes.pagination.actualPage });
    this.updateUrlWithPage();
    this.searching = false;
  }

  private updateUrlWithPage() {
    const page = this.routes()?.pagination.actualPage || 1;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { routesPage: page > 1 ? page : null },
      queryParamsHandling: 'merge',
    });
  }

  createNewRoute() {
    this.createEventEmitter.emit();
  }

  openMultiConfig() {
    this.multiConfigEventEmitter.emit();
  }

  hideRoute(data: any) {
    const route = this.routes()?.value.find(
      (route: any) => route.id === data.id,
    );
    route!.visible = !route?.visible;
    this.hideRoutes.emit(this.routes()!.value);
  }
}
